import React from 'react';
export var RadioGroupContext = React.createContext({});
//# sourceMappingURL=radio-group-context.js.map